/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IWinRatioConfig} from "../core/config/WinRatio";
import {BetWinMode} from "../core/config/BetWinMode";
import {IReelSets} from "../core/reel/reelset/ReelSet";
import {StackedSymbol} from "../core/reel/stackedsymbol/StackedSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {SerialSymbolConfig} from "./symbol/SerialSymbolConfig";


export class SerialGameConfig {

    // Game basic
    public static BET_WIN_MODE:BetWinMode = BetWinMode.BET_WAY;

    // Reels
    public static REELS_NUM:number = 5;

    // Win
    public static WIN_RATIOS:IWinRatioConfig[] = [
        {
            ratio : 0,
            name : "Tiny",
            duration : 0.01,
            bigWinLevel : -1
        },
        {
            ratio : 1.5,
            name : "Small",
            duration : 0.01,
            bigWinLevel : -1
        },
        {
            ratio : 3,
            name : "Medium",
            duration : 0.4,
            bigWinLevel : -1
        },
        {
            ratio : 5,
            name : "Large",
            duration : 0.8,
            bigWinLevel : -1
        },
        {
            ratio : 15,
            name : "Big Win 1",
            duration : 5.0,
            bigWinLevel : 0
        },
        {
            ratio : 25,
            name : "Big Win 2",
            duration : 5.0,
            bigWinLevel : 1

        },
        {
            ratio : 50,
            name : "Big Win 3",
            duration : 5.0,
            bigWinLevel : 2
        },
        {
            ratio : 100,
            name : "Big Win 4",
            duration : 5.0,
            bigWinLevel : 3
        },
        {
            ratio : 500,
            name : "Big Win 5",
            duration : 5.0,
            bigWinLevel : 4
        }
    ];

    public static REEL_SETS:IReelSets = {
        "NORMAL_REELSET" : [
            ["M4", "L1", "L4", "M5", "L3", "M5", "L2", "L4", "M4", "M4", "L3", "M4", "L2", "M4", "L3", "L1", "M2", "L5",
                "L1", "M4", "L2", "L1", "M2", "L4", "L5", "M4", "L1", "L4", "L2", "M3", "L4", "L2", "L5", "M3", "L5",
                "L2", "M5", "L3", "M5", "L2", "L3", "L5", "M1", "L4", "L4", "L2", "M5", "L1", "L3", "M5", "L1", "M5",
                "L2", "L1", "M3", "L2", "M1", "L1", "L5", "M5", "L2", "M3", "L3", "L1", "M5", "L4", "L4", "M2", "L2",
                "L3", "M5", "L4", "M3", "L3", "L5", "L4", "M4", "L3", "L4", "M5", "L5", "L4", "M4", "L2", "L5", "M4",
                "L3", "L2", "M2", "L5", "L4"],
            ["M4", "L1", "L5", "M5", "S1", "L1", "L2", "WXN", "WXN", "WXN", "M3", "L1", "M5", "M1", "S1", "L5", "L3",
                "M5", "M1", "S1", "M5", "L4", "S1", "M1", "L4", "M5", "L1", "M2", "M4", "S1", "L3", "M2", "L5", "M5",
                "M2", "S1", "L4", "M2", "M5", "L4", "M4", "L1", "M2", "M5", "M1", "L4", "M3", "L1", "M2", "L3", "M5",
                "L5", "L3", "M5", "M5", "M2", "L4", "M5", "M2", "L5", "M5", "L4", "M3", "M1", "L5", "L2", "L3", "M2",
                "L4", "L5", "M3", "L4", "W", "L3", "L5", "L4", "L1", "L1", "L2", "L4", "L1", "L5", "L4", "L3", "L5",
                "L4", "L2", "L1", "L4", "L3", "L1", "L4", "L1"],
            ["L2", "L1", "M3", "M2", "M3", "M5", "WXN", "WXN", "WXN", "L3", "M5", "M4", "M3", "M2", "M5", "M4", "S1",
                "L5", "L1", "M2", "M3", "M1", "M5", "M4", "L4", "L2", "M2", "M4", "L2", "L5", "M3", "M4", "L4", "M5",
                "M2", "L4", "L1", "L5", "M4", "W", "L4", "L1", "M4", "L4", "L2", "L3", "L4", "L5", "L2", "L4", "L3",
                "L2", "L5", "L4", "L1", "L5", "L2", "L4", "L5", "L3", "L1", "L5", "L4", "L2", "L5", "L4", "M2", "L2",
                "L3", "L5", "L2", "L3", "L4", "L2", "L5", "L3", "L4", "L2", "L3", "L5", "M4", "L2", "L3", "M3", "L4",
                "L5", "L2", "M3", "L4", "L3", "M4", "L2", "L5", "M1", "L3", "L5"],
            ["L3", "M5", "S1", "L4", "L2", "M3", "L4", "WXN", "WXN", "WXN", "M1", "M4", "M2", "M5", "M4", "S1", "L3",
                "M3", "M5", "M1", "M2", "M5", "M4", "L5", "L4", "M3", "L5", "M4", "M5", "M2", "M1", "M2", "M3", "M1",
                "M3", "M5", "L4", "M5", "M3", "M4", "M2", "M1", "M4", "L1", "L5", "M5", "M2", "S1", "L4", "L1", "L2",
                "W", "L3", "L2", "L1", "M3", "M2", "M2", "M3", "L1", "L4", "L2", "L5", "L3", "L4", "L1", "L3", "L4",
                "L2", "L1", "L4", "L2", "L3", "L4", "L1", "L2"],
            ["S2", "L2", "M5", "L2", "L3", "M4", "L5", "L5", "L4", "M4", "L5", "M5", "M4", "L3", "L3", "L5", "M1", "L3",
                "L2", "M4", "M3", "L4", "M3", "M4", "L2", "L5", "L4", "M2", "M1", "L5", "M3", "M5", "L1", "M3", "M5",
                "L5", "M5", "L2", "L4", "M5", "L1", "M2", "L2", "L5", "L1", "L4", "L1", "M3", "L2", "L3", "M5", "M5",
                "L2", "L5", "L2", "L4", "L3", "L2", "M1", "L5", "M4", "M2", "M1", "L1", "M2", "L2", "L5", "L1", "L2",
                "M5", "L2", "L3", "M4", "L5", "L5", "L4", "M4", "L5", "M5", "M4", "L3", "L3", "L5", "M1", "L3", "L2",
                "M4", "M3", "L4", "M3", "M4", "L2", "L5", "L4", "M2", "M1", "L5", "M3", "M5", "L1", "M3", "M5", "L5",
                "M5", "L2", "L4", "M5", "L1", "M2", "L2", "L5", "L1", "L4", "L1", "M3", "L2", "L3", "M5", "M5", "L2",
                "L5", "L2", "L4", "L3", "L2", "M1", "L5", "M4", "M2", "M1", "L1", "M2", "L2", "L5", "L1", "L2", "M5",
                "L2", "L3", "M4", "L5", "L5", "L4", "M4", "L5", "M5", "M4", "L3", "L3", "L5", "M1", "L3", "L2", "M4",
                "M3", "L4", "M3", "M4", "L2", "L5", "L4", "M2", "M1", "L5", "M3", "M5", "L1", "M3", "M5", "L5", "M5",
                "L2", "L4", "M5", "L1", "M2", "L2", "L5", "L1", "L4", "L1", "M3", "L2", "L3", "M5", "M5", "L2", "L5",
                "L2", "L4", "L3", "L2", "M1", "L5", "M4", "M2", "M1", "L1", "M2", "L2", "L5", "L1"]
        ],
        "XBET_REELSET" : [
            ["M4", "L1", "L4", "M5", "L3", "M5", "L2", "L4", "M4", "M4", "L3", "M4", "L2", "M4", "L3", "L1", "M2", "L5",
                "L1", "M4", "L2", "L1", "M2", "L4", "L5", "M4", "L1", "L4", "L2", "M3", "L4", "L2", "L5", "M3", "L5",
                "L2", "M5", "L3", "M5", "L2", "L3", "L5", "M1", "L4", "L4", "L2", "M5", "L1", "L3", "M5", "L1", "M5",
                "L2", "L1", "M3", "L2", "M1", "L1", "L5", "M5", "L2", "M3", "L3", "L1", "M5", "L4", "L4", "M2", "L2",
                "L3", "M5", "L4", "M3", "L3", "L5", "L4", "M4", "L3", "L4", "M5", "L5", "L4", "M4", "L2", "L5", "M4",
                "L3", "L2", "M2", "L5", "L4"],
            ["S1", "M4", "L1", "S1", "L5", "M5", "S1", "M3", "L1", "S1", "M5", "M1", "S1", "L5", "L3", "S1", "L3", "M5",
                "S1", "L5", "M3", "S1", "M5", "M1", "S1", "M5", "L4", "S1", "M1", "M5", "L1", "S1", "M2", "M4", "S1",
                "L3", "M2", "S1", "L1", "W", "S1", "L5", "M5", "S1", "M2", "L4", "S1", "M5", "L4", "M4", "S1", "L1",
                "M2", "S1", "M5", "M1", "S1", "L4", "M3", "S1", "L5", "L3", "S1", "M5", "M2", "L4", "S1", "M5", "M2",
                "S1", "L5", "M5", "S1", "L4", "M3", "S1", "M1", "L5", "S1", "L4", "L3", "S1", "L5", "L1", "L1", "S1",
                "L2", "L4", "S1", "L1", "L5", "S1", "L4", "L3", "S1", "L5", "L4", "S1", "L1", "L4", "S1", "L3", "L4",
                "L1", "S1", "L2", "L3", "S1", "M2", "L4"],
            ["L2", "L1", "M3", "M2", "M3", "M5", "WXN", "WXN", "WXN", "L3", "M5", "M4", "M3", "M2", "M5", "M4", "S1",
                "L5", "L1", "M2", "M3", "M1", "M5", "M4", "L4", "L2", "M2", "S1", "L2", "L5", "M3", "L4", "M5", "L4",
                "L1", "L5", "M4", "S1", "L4", "L1", "M4", "L4", "L2", "L4", "L5", "L4", "L3", "L2", "L5", "L4", "L1",
                "L5", "W", "L4", "L5", "M3", "L1", "L5", "L4", "L2", "L5", "WXN", "WXN", "WXN", "L4", "M2", "L3", "M3",
                "L2", "L3", "L4", "L2", "L5", "L3", "L4", "L2", "L3", "M4", "L2", "L3", "M3", "L4", "L2", "M3", "L4",
                "L3", "M4", "L2", "L5", "M1", "L3", "L5"],
            ["L3", "M5", "S1", "L4", "L2", "M3", "L4", "WXN", "WXN", "WXN", "M1", "M4", "M2", "M5", "M4", "L3", "M3",
                "M5", "M1", "M2", "M5", "M4", "S1", "L4", "M3", "L5", "M4", "M5", "M2", "M1", "M2", "M3", "M1", "M3",
                "M5", "L4", "M5", "M3", "M4", "M2", "M1", "M4", "L1", "L5", "M5", "M2", "L4", "L1", "L2", "M3", "L3",
                "L2", "L1", "M3", "M2", "M2", "M3", "L1", "L4", "L2", "L5", "S1", "L4", "L1", "L3", "L4", "L2", "L1",
                "L4", "L2", "L3", "L4", "L1", "L2", "L4", "M3", "L5", "M4", "M5", "M2", "M1", "M2", "M3", "M1", "L5",
                "M5", "M2", "L4", "L1", "L2", "W", "L3", "L2", "L1", "M3", "M2", "S1", "M3", "L1", "L4", "L2", "L5",
                "L4", "L1"],
            ["S2", "L2", "M5", "L2", "L3", "M4", "L5", "L5", "L4", "M4", "L5", "M5", "M4", "L3", "L3", "L5", "M1", "L3",
                "L2", "M4", "M3", "L4", "M3", "M4", "L2", "L5", "L4", "M2", "M1", "L5", "M3", "M5", "L1", "M3", "M5",
                "L5", "M5", "L2", "L4", "M5", "L1", "M2", "L2", "L5", "L1", "L4", "L1", "M3", "L2", "L3", "M5", "M5",
                "L2", "L5", "L2", "L4", "L3", "L2", "M1", "L5", "M4", "M2", "M1", "L1", "M2", "L2", "L5", "L1", "L2",
                "M5", "L2", "L3", "M4", "L5", "L5", "L4", "M4", "L5", "M5", "M4", "L3", "L3", "L5", "M1", "L3", "L2",
                "M4", "M3", "L4", "M3", "M4", "L2", "L5", "L4", "M2", "M1", "L5", "M3", "M5", "L1", "M3", "M5", "L5",
                "M5", "L2", "L4", "M5", "L1", "M2", "L2", "L5", "L1", "L4", "L1", "M3", "L2", "L3", "M5", "M5", "L2",
                "L5", "L2", "L4", "L3", "L2", "M1", "L5", "M4", "M2", "M1", "L1", "M2", "L2", "L5", "L1", "L2", "M5",
                "L2", "L3", "M4", "L5", "L5", "L4", "M4", "L5", "M5", "M4", "L3", "L3", "L5", "M1", "L3", "L2", "M4",
                "M3", "L4", "M3", "M4", "L2", "L5", "L4", "M2", "M1", "L5", "M3", "M5", "L1", "M3", "M5", "L5", "M5",
                "L2", "L4", "M5", "L1", "M2", "L2", "L5", "L1", "L4", "L1", "M3", "L2", "L3", "M5", "M5", "L2", "L5",
                "L2", "L4", "L3", "L2", "M1", "L5", "M4", "M2", "M1", "L1", "M2", "L2", "L5", "L1"]
        ],
        "FREESPIN_REELSET" : [
            ["L2", "M5", "L3", "M4", "L4", "M5", "L2", "L5", "M2", "L4", "M4", "L2", "M3", "L4", "L2", "M5", "L3", "L5",
                "M3", "L2", "L3", "M3", "L4", "L4", "M5", "L1", "L2", "M2", "L3", "L5", "M4", "L1", "L3", "M5", "L1",
                "L2", "M4", "L3", "L4", "M4", "L3", "L4", "M3", "L5", "L2", "M4", "L3", "L5", "M3", "L1", "L3", "M4",
                "L3", "L4", "M3", "L5", "L2", "M2", "L5", "M4", "L2", "M3", "L2", "L5", "M2", "L1", "L2", "M5", "L1",
                "M2", "L3", "M1", "L4", "L3", "M2", "L1", "L4", "M1", "L1", "L5", "M1", "L2", "L2", "M1", "L5", "L4",
                "M4", "L1", "L4", "M4", "L4"],
            ["L4", "L1", "L4", "M3", "L5", "L4", "W", "M5", "L4", "L1", "M5", "W", "L2", "L1", "L5", "L1", "L5", "L3",
                "M2", "M1", "L4", "WXN", "WXN", "WXN", "L1", "M3", "L1", "M4", "M2", "L5", "M5", "M4", "L3", "M5", "L4",
                "M1", "L1", "M4", "W", "L1", "M2", "L1", "L3", "L4", "L5", "M1", "L5", "L2", "L1", "M3", "W", "L1",
                "M5", "L5", "L3", "L1", "M2", "W", "M1", "L2", "W", "M3", "L2", "M5", "L2", "L1", "L3", "L4", "M4",
                "L1", "L4", "M5", "L5", "L4", "M2", "L1", "L4", "L1", "M2", "L4", "L1", "M2", "L1", "L3", "L4", "L5",
                "M1", "L5", "L2", "L1", "M3", "L4", "L1", "M5", "L5", "L3", "L1", "M2", "M5", "M1", "L2", "M5", "W",
                "L2", "M5", "L2", "L1", "W", "L4", "M4", "L1", "L4", "M5", "L5", "L4", "M2", "L1", "L4", "L1", "M2",
                "L4", "L1", "M2", "L1", "L3", "L4", "L5", "M1", "L5", "L2", "L1", "M3", "L4", "L1", "M5", "L5", "L3",
                "L1", "M2", "M5", "M1", "L2", "M5", "M3", "L2", "M5", "L2", "L1", "L3", "L4", "M4", "L1", "L4", "M5",
                "L5", "L4", "M2", "L1", "L4", "L1", "M2", "L4"],
            ["M3", "L5", "L2", "L4", "M4", "L3", "W", "L5", "L3", "M3", "L2", "L5", "WXN", "WXN", "WXN", "M5", "M3",
                "L3", "L4", "M3", "L5", "L2", "L4", "L5", "L2", "M2", "M4", "L2", "L4", "M4", "L2", "L4", "L3", "L4",
                "M3", "L3", "M5", "L4", "M1", "M4", "M3", "L1", "W", "L2", "L4", "L3", "M1", "M4", "L2", "L4", "M3",
                "L3", "M4", "L5", "W", "M5", "L5", "L2", "M1", "M4", "L5", "L2", "M1", "M4", "L5", "L1", "M5", "L3",
                "L4", "M1", "L5", "M3", "L3", "L2", "M3", "L1", "M5", "L5", "M1", "L3", "M2", "L4", "L5", "M5", "L2",
                "L1", "M2", "L3", "M4", "L2", "M4", "M3", "L1", "M4", "L2", "L4", "L3", "M1", "M4", "L2", "L4", "M3",
                "L3", "M4", "L5", "L4", "M5", "L5", "L2", "M1", "M4", "L5", "L2", "M1", "M4", "L5", "L1", "M5", "L3",
                "L4", "M1", "L5", "M3", "L3", "L2", "M3", "L1", "M5", "L5", "M1", "L3", "M2", "L4", "L5", "M5", "L2",
                "L1", "M2", "L3", "M4", "L2"],
            ["L4", "L3", "M5", "L5", "L4", "M5", "L2", "L1", "M4", "L1", "W", "M3", "L4", "L3", "L2", "M2", "L4", "L2",
                "L5", "L4", "L2", "L1", "L3", "L2", "M1", "L4", "L2", "WXN", "WXN", "WXN", "M3", "L1", "L5", "M2", "L1",
                "L2", "L5", "M1", "L5", "L5", "L4", "M5", "L2", "L4", "L3", "M1", "L4", "M2", "L5", "L1", "L2", "L5",
                "M5", "L3", "M5", "L5", "L2", "L4", "L4", "M1", "L3", "M5", "L4", "L2", "M5", "L4", "M4", "L5", "L2",
                "L5", "L1", "L2", "L3", "M3", "L4", "L2", "L3", "L2", "M4", "L3", "L2", "M2", "M1", "M2", "L5", "M2",
                "L5", "L1", "L2", "L5", "M5", "L3", "M5", "L5", "L2", "L4", "L4", "M1", "L3", "M5", "L4", "L2", "M5",
                "L4", "M4", "L5", "L2", "L5", "L1", "L2", "L3", "M3", "L4", "L2", "L3", "L2", "M4", "L3", "L2", "M2",
                "M1", "M2", "L5"],
            ["L3", "S2", "M5", "L4", "L5", "M4", "L3", "L2", "M3", "M5", "L3", "M1", "L4", "L5", "M2", "L3", "L1", "M5",
                "L4", "L5", "M4", "L3", "L2", "M3", "M5", "L3", "M1", "L4", "L5", "M2", "L3", "L1", "M5", "L4", "L5",
                "M4", "L3", "L2", "M3", "M5", "L3", "M1", "L4", "L5", "M2"]
        ],
        "FREESPIN_SUPER_REELSET" : [
            ["L2", "M5", "L3", "M4", "L4", "M5", "L2", "L5", "M2", "L4", "M4", "L2", "M3", "L4", "L2", "M5", "L3", "L5",
                "M3", "L2", "L3", "M3", "L4", "L4", "M5", "L1", "L1", "M2", "L3", "L5", "M4", "L1", "L3", "M5", "L1",
                "L2", "M4", "L3", "L4", "M4", "L3", "L4", "M3", "L5", "L2", "M4", "L3", "L5", "M3", "L1", "L3", "M4",
                "L3", "L4", "M3", "L5", "L2", "M2", "L5", "M4", "L2", "M3", "L2", "L5", "M2", "L2", "M5", "L1", "M2",
                "L3", "M1", "L4", "L3", "M2", "L1", "L4", "M1", "L1", "L5", "M1", "L2", "L2", "M1", "L5", "L4", "M4",
                "L1", "L4", "M4", "L4"],
            ["L4", "L1", "L4", "M3", "L5", "L4", "L3", "M5", "M5", "L4", "L1", "L4", "L2", "L1", "L5", "L1", "L5", "L3",
                "M2", "M1", "L4", "WXN", "WXN", "WXN", "L1", "M3", "L1", "M4", "M2", "L5", "M5", "M4", "L3", "M5", "L4",
                "M1", "L1", "M4", "W", "L1", "M2", "L1", "L3", "L4", "L5", "M1", "M2", "L2", "L1", "M3", "L4", "L1",
                "M5", "L5", "L3", "L1", "M2", "M5", "M1", "L2", "M5", "M3", "L2", "M5", "L2", "L1", "L3", "L4", "M4",
                "L1", "L4", "M5", "L5", "L4", "M2", "L1", "L4", "L1", "M2", "L4", "L4", "L1", "L4", "M3", "L5", "L4",
                "L3", "M5", "M5", "L4", "L1", "L4", "L2", "L1", "L5", "L1", "L5", "L3", "M2", "M1", "L4", "L1", "M3",
                "L1", "M4", "M2", "L5", "M5", "M4", "L3", "M5", "L4", "M1", "L1", "M4", "L1", "M2", "L1", "L3", "L5",
                "M1", "M2", "L5", "L2", "L1", "M3", "L4", "L1", "M5", "L5", "L3", "L1", "M2", "M5", "M1", "L2", "M5",
                "M3", "L2", "M5", "L2", "L1", "L3", "L4", "M4", "L1", "L4", "M5", "L5", "L4", "M2", "L1", "L4", "L1",
                "M2", "L4"],
            ["M3", "L5", "L2", "L4", "M4", "L3", "W", "L5", "L3", "M3", "L2", "L5", "WXN", "WXN", "WXN", "M5", "M3",
                "L3", "L4", "M3", "L5", "L2", "L4", "L5", "L2", "M2", "M4", "L2", "L4", "M4", "L2", "L4", "L3", "L4",
                "M3", "L3", "M5", "L4", "M1", "M4", "M3", "L1", "M4", "L2", "L4", "L3", "M1", "M5", "M4", "L2", "L4",
                "M3", "L3", "M4", "L5", "L4", "L5", "L2", "M1", "M4", "M5", "M3", "L5", "L2", "M1", "M4", "L5", "L1",
                "L3", "L4", "M1", "L5", "M3", "L3", "L2", "L1", "M5", "L5", "M1", "L3", "M2", "M5", "L4", "L5", "L2",
                "L1", "M2", "L3", "M4", "L2", "M5", "L5", "M1", "L3", "M2", "M5", "L4", "L5", "L2", "L1", "M2", "L3",
                "M4", "L2", "M3", "L5", "L2", "L4", "M4", "L3", "W", "L5", "L3", "M3", "L2", "L5", "M5", "M3", "L3",
                "L4", "M3", "L5", "L2", "L4", "L5", "L2", "M2", "M4", "L2", "L4", "M4", "L2", "L4", "L3", "L4", "M3",
                "L3", "M5", "L4", "M1", "M4", "M3", "L1", "M4", "L2", "L4", "L3", "M1", "M5", "M4", "L2", "L4", "M3",
                "L3", "M4", "L5", "L4", "L5", "L2", "M1", "M4", "M5", "M3", "L5", "L2", "M1", "M4", "L5", "L1", "L3",
                "L4", "M1", "L5", "M3", "L3", "L2", "L1", "M5", "L5", "M1", "L3", "M2", "M5", "L4", "L5", "L2", "L1",
                "M2", "L3", "M4", "L2", "M5", "L5", "M1", "L3", "M2", "M5", "L4", "L5", "L2", "L1", "M2", "L3", "M4",
                "L2"],
            ["L4", "L3", "M5", "L5", "L4", "M5", "L2", "L1", "M4", "L1", "W", "M3", "L4", "L3", "L2", "M2", "L4", "L2",
                "L5", "L4", "L2", "L1", "L3", "L2", "M1", "L4", "L2", "WXN", "WXN", "WXN", "M3", "L1", "L5", "M2", "L1",
                "L2", "L5", "M1", "L5", "L5", "L4", "M5", "L2", "L4", "L3", "M1", "L4", "M2", "L5", "L1", "L2", "L5",
                "M5", "L3", "M5", "L5", "L2", "L4", "L4", "M1", "L3", "M5", "L4", "L2", "M5", "L4", "M4", "L5", "L2",
                "L5", "L1", "L2", "L3", "M3", "L4", "L2", "L3", "L2", "M4", "L3", "L2", "M2", "M1", "M2", "L5"],
            ["L3", "L1", "M5", "L4", "L5", "M4", "L3", "L2", "M3", "M5", "L3", "M1", "L4", "L5", "M2"]
        ],
        "ENHANCER_REELSET" : [
            ["M4", "M1", "W", "X", "M3", "M5", "M2", "M4", "M4", "M4", "M3", "M4", "M2", "M4", "M3", "M1", "M2", "M5",
                "M1", "M4", "M2", "M1", "M2", "X", "M5", "M4", "M1", "M4", "M2", "M3", "M4", "M2", "M5", "M3", "M5",
                "M2", "M5", "M3", "M5", "M2", "M3", "M5", "M1", "M4", "M4", "M2", "X", "M1", "M3", "M5", "M1", "M5",
                "M2", "X", "M3", "M2", "M1", "M1", "M5", "M5", "M2", "M3", "M3", "M1", "M5", "M4", "M4", "M2", "M2",
                "M3", "M5", "M4", "M3", "M3", "X", "M4", "M4", "M3", "M4", "M5", "M5", "M4", "M4", "M2", "M5", "M4",
                "M3", "M2", "M2", "M5", "M4"],
            ["M4", "M1", "X", "M5", "M1", "M1", "M2", "WXN", "M3", "M1", "M5", "M1", "M1", "M5", "M3", "M5", "M1", "M1",
                "M5", "M4", "M1", "M1", "M4", "M5", "M1", "M2", "M4", "M1", "M3", "M2", "M5", "M5", "M2", "M1", "M4",
                "M2", "M5", "M4", "M4", "M1", "M2", "M5", "M1", "M4", "M3", "M1", "M2", "M3", "M5", "X", "M3", "M5",
                "M5", "M2", "M4", "M5", "X", "M5", "M5", "M4", "M3", "M1", "M5", "M2", "M3", "M2", "M4", "M5", "M3",
                "M4", "W", "M3", "M5", "M4", "M1", "M1", "M2", "M4", "M1", "M5", "M4", "M3", "M5", "M4", "M2", "M1",
                "M4", "M3", "M1", "M4", "M1"],
            ["M2", "M1", "M3", "M2", "M3", "M5", "WXN", "M3", "M5", "M4", "M3", "M2", "M5", "M4", "M1", "M5", "M1",
                "M2", "M3", "M1", "W", "M4", "M4", "X", "M2", "M4", "M2", "M5", "M3", "M4", "M4", "M5", "M2", "M4",
                "M1", "M5", "M4", "W", "M4", "M1", "M4", "M4", "M2", "M3", "M4", "M5", "M2", "M4", "M3", "M2", "X",
                "M4", "M1", "M5", "M2", "M4", "M5", "M3", "M1", "M5", "M4", "M2", "M5", "M4", "M2", "M2", "M3", "M5",
                "M2", "M3", "M4", "M2", "M5", "M3", "M4", "M2", "M3", "M5", "M4", "M2", "M3", "M3", "M4", "M5", "M2",
                "M3", "M4", "M3", "M4", "M2", "M5", "M1", "M3", "M5"],
            ["W", "M5", "M1", "X", "M2", "M3", "M4", "WXN", "M1", "M4", "M2", "M5", "M4", "M1", "M3", "M3", "M5", "M1",
                "M2", "M5", "M4", "M5", "M4", "M3", "M4", "M4", "M5", "M2", "M1", "M2", "M3", "M1", "M3", "M5", "M4",
                "M5", "M3", "M4", "M2", "M1", "M4", "M1", "M5", "M5", "M2", "M1", "M4", "M1", "M2", "W", "M3", "X",
                "M1", "M3", "M2", "M2", "M3", "M1", "M4", "M2", "M5", "M3", "M4", "M1", "M3", "M4", "M2", "M1", "M4",
                "M2", "M3", "M4", "M1", "M2"],
            ["M2", "M2", "M5", "M2", "X", "M4", "M5", "M5", "W", "M4", "M5", "M5", "M4", "M3", "M3", "M5", "M1", "M3",
                "M2", "M4", "M3", "M4", "M3", "M4", "M2", "M5", "M4", "M2", "M1", "M5", "M3", "M5", "M1", "M3", "M5",
                "M5", "M5", "M2", "M4", "M5", "M1", "M2", "M2", "M5", "M1", "M4", "M1", "M3", "M2", "M3", "M5", "M5",
                "M2", "M5", "M2", "M4", "M3", "M2", "X", "M5", "M4", "M2", "M1", "M1", "M2", "M2", "M5", "M1"]
        ]
    };

    public static getReelSetName(mode:string):string {
        switch(mode) {
            case "NORMAL":
            case "RESPIN":
                return "NORMAL_REELSET";
            case "FREESPIN":
            case "FREESPIN_RESPIN":
                return "FREESPIN_REELSET";
            case "FREESPIN_SUPER":
            case "FREESPIN_SUPER_RESPIN":
                return "FREESPIN_SUPER_REELSET";
            default:
                return "NORMAL_REELSET";
        }
    }

    public static getReelSet(name:string, reelId:number):string[] {
        if(SerialGameConfig.REEL_SETS[name]) {
            const reelSet:string[] = SerialGameConfig.REEL_SETS[name][reelId];
            if(reelSet.length < 5) {
                Logger.logDev(`GameConfig.getReelSet() name = ${name}, reelId = ${reelId}, the reelSet is too short that might break ReelController.randomizeReelSetPosition().`)
            }
            return reelSet;
        }

        debugger;
        throw new Error(`GameConfig.getReelSet(): ReelSet ${name} is missing from GameConfig!`);
    }

    public static getRandomSymbolNameFromReelSet(reelSet:string[]):string {
        let symbolName:string;
        do {
            symbolName = ArrayHelper.getRandomValue<string>(reelSet);
        } while(symbolName.includes("W") || SerialSymbolConfig.SYMBOLS[symbolName].isSpecial);

        return symbolName;
    }

    public static updateReelSets():void {
        // Filter stacked symbols on REEL_SETS if any.
        for(let reelSetKey in this.REEL_SETS) {
            this.REEL_SETS[reelSetKey].forEach((reelSet:string[], reelId:number) => {
                if(reelSetKey.includes("ENHANCER")) {
                    return;
                }
                this.REEL_SETS[reelSetKey][reelId] = StackedSymbol.filterStackedSymbolsReelSet(reelSet, reelId);
            });
        }
    }
}